import React, { useState } from "react";
import { graphql } from "gatsby";
import "./deptBlockPeople.scss";
import PeopleModal from "./PeopleModal";
import DefaultDepartmentPeopleList from "./DefaultDepartmentPeopleList";
import GridDepartmentBlockPeopleList from "./GridDepartmentPeopleList";

export const ParagraphDepartmentBlockPeople = ({ node }) => {
  const [detail, setDetail] = useState({ open: false, data: null });

  const handleShowDetails = (ev, i) => {
    ev.preventDefault();
    setDetail({ open: true, data: i });
  };

  const { field_depatment_people_title, field_view_mode } = node;

  return (
    <div className={`dept-people ${field_view_mode === 'biography' ? 'dept-people-biography' : ''}`}>
      {
        field_view_mode === 'biography' ? (
          <GridDepartmentBlockPeopleList
            handleShowDetails={handleShowDetails}
            title={field_depatment_people_title}
            fieldDepartmentPeoples={node?.relationships?.field_department_peoples}
          />
        ) : (
          <DefaultDepartmentPeopleList
            handleShowDetails={handleShowDetails}
            title={field_depatment_people_title}
            fieldDepartmentPeoples={node?.relationships?.field_department_peoples}
          />
        )
      }
      <PeopleModal detail={detail} setDetail={setDetail}/>
    </div>
  );
};

export const fragment = graphql`
  fragment ParagraphDepartmentBlockPeople on paragraph__department_block_people {
    id
    field_depatment_people_title
    field_view_mode
    relationships {
      field_department_peoples {
        relationships {
          field_department_people_icon {
            gatsbyImage(
              width: 500
              height: 500
              quality: 100
              placeholder: BLURRED
            )
          }
        }
        field_department_people_name
        field_department_people_title
        field_people_read_more_expand {
          format
          processed
          value
        }
        field_department_people_email
        field_social_profile_links {
          platform_values {
            linkedin {
              value
            }
            twitter {
              value
            }
            youtube {
              value
            }
          }
        }
      }
    }
  }
`;

export default ParagraphDepartmentBlockPeople;
